import { FC } from 'react';
import { IsoLogo, WhiteLogo } from '@/assets/logos';
import useSidebarContext from '@/hooks/useSidebarContext';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbTack } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { PagesPaths } from '@/enums';
import { DesktopMenu } from '../Menu';
import styles from './Sidebar.module.scss';

const Sidebar: FC = () => {
  const {
    isSidebarActive,
    setIsSidebarActive,
    isSidebarAnchored,
    setIsSidebarAnchored,
  } = useSidebarContext();

  const handleMouseEnter = () => {
    setIsSidebarActive(true);
  };

  const handleMouseLeave = () => {
    setIsSidebarActive(false);
  };

  const toggleSidebarAnchor = () => {
    setIsSidebarAnchored(!isSidebarAnchored);
  };

  const sidebarOpen = isSidebarActive || isSidebarAnchored;

  return (
    <div
      className={classNames(styles.sidebar, sidebarOpen && styles.sidebarOpen)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <header>
        <Link to={PagesPaths.PrivateHome} className={styles.appLogo}>
          <WhiteLogo className={styles.appLogoNormal} />
          <IsoLogo className={styles.appLogoSmall} />
        </Link>
        {sidebarOpen && (
          <button
            type="button"
            aria-label="anchor sidebar"
            onClick={toggleSidebarAnchor}
          >
            <FontAwesomeIcon icon={faThumbTack} className={styles.anchorIcon} />
          </button>
        )}
      </header>
      <div className={styles.content}>
        <DesktopMenu />
      </div>
    </div>
  );
};

export default Sidebar;
